import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4bf70500&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Edit.vue?vue&type=style&index=1&id=4bf70500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf70500",
  null
  
)

export default component.exports